import { MutableRefObject, useContext, useRef } from 'react'
import CONFIG, { IS_PRODUCTION } from '../../config'
import { BUILD_CONSTANTS as BC, SELECTED_POLICY_NUMBER } from '../../constants'
import { AVTALEGIRO_TEST_KID, COOKIE_KID } from '../../constants/auth-constants'
import { SessionDataNoBID } from '../../types/interface/session.interface'
import { getCookieByName } from '@dg-util'
import { getSessionStorageAuthData } from '../../service/util.service'
import { Context } from '@dg-shared/ContextProvider'

export interface UseAvtalegiroReturn {
  avtalegiroFormRef: MutableRefObject<HTMLFormElement | null>
  KID: string
  returnUrl: string
  actionUrl: string
  companyName: string
  companyAccountNumber: string
  handleCreateAvtalegiro: (policyNumber: string) => void
}

const useAvtalegiro = (): UseAvtalegiroReturn => {
  const { setContext } = useContext(Context)
  const avtalegiroFormRef = useRef<HTMLFormElement | null>(null)
  const policyNumberRef = useRef<string>('')

  const parsedUserInfo = getSessionStorageAuthData(CONFIG.USER_INFO_KEY) as SessionDataNoBID
  const KID: string = IS_PRODUCTION
    ? (((parsedUserInfo && parsedUserInfo.kid) || getCookieByName(COOKIE_KID)) as string)
    : AVTALEGIRO_TEST_KID

  const handleCreateAvtalegiro = (policyNumber: string) => {
    setContext({ [SELECTED_POLICY_NUMBER]: policyNumber })
    policyNumberRef.current = policyNumber

    const avtalegiroFormCurrentRef = avtalegiroFormRef.current

    if (!avtalegiroFormCurrentRef) {
      // This should never happen
      // Type safety check
      return
    }

    const returnUrlInputRef = avtalegiroFormCurrentRef.elements.namedItem(
      'returnUrl'
    ) as HTMLInputElement | null

    if (!returnUrlInputRef) {
      // This should never happen
      // Type safety check
      return
    }

    // Directly update the hidden input value before submit to avoid async state lag
    returnUrlInputRef.value = `${BC.REST_URL}/payment?flow=mypages&policyNumber=${policyNumber}`
    avtalegiroFormCurrentRef.submit()
  }

  const returnUrl = `${BC.REST_URL}/payment?flow=mypages&policyNumber=${policyNumberRef.current}`

  return {
    avtalegiroFormRef,
    KID,
    returnUrl,
    actionUrl: `${BC.AVTALEGIRO_URL}/ecsa/start`,
    companyName: BC.PARTNER_NAME_AVTALEGIRO,
    companyAccountNumber: BC.ACCOUNT_NUMBER,
    handleCreateAvtalegiro,
  }
}

export default useAvtalegiro
